module.exports = __webpack_public_path__ + "media/flags/sg-15dcabd5.svg";